// « Billet de retour » du calendrier « Mes demandes » : quand on ouvre une fiche ou l'assistant depuis une carte, on revient (bouton
// Précédent ou flèche de la fiche) sur le MÊME mois, en vue Calendrier, avec le focus sur la carte d'où l'on est parti — jamais perdu·e.
// Rien n'est mémorisé durablement : le billet est lu une fois au retour, puis effacé ; il vit le temps de l'onglet (sessionStorage).

const CLE = 'portail.retour-calendrier';

export interface RetourCalendrier {
  /** Le mois affiché, 'AAAA-MM'. */
  mois: string;
  /** La carte d'où l'on est parti (data-cle), pour lui rendre le focus. */
  cle: string | null;
}

/** Au-delà, on n'est plus « en train de revenir » d'une fiche : le billet est ignoré. */
export const DUREE_BILLET_MS = 10 * 60 * 1000;

export function memoriserRetourCalendrier(retour: RetourCalendrier, maintenant: number = Date.now()): void {
  try { sessionStorage.setItem(CLE, JSON.stringify({ ...retour, quand: maintenant })); } catch { /* stockage indisponible : on revient simplement à la liste */ }
}

/** Lit le billet sans l'effacer (l'effacement se fait dans un effet : un rendu peut être rejoué). */
export function lireRetourCalendrier(maintenant: number = Date.now()): RetourCalendrier | null {
  try {
    const brut = sessionStorage.getItem(CLE);
    if (!brut) return null;
    const r = JSON.parse(brut) as Partial<RetourCalendrier> & { quand?: number };
    if (typeof r.quand !== 'number' || maintenant - r.quand > DUREE_BILLET_MS || maintenant < r.quand) return null;
    return typeof r.mois === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(r.mois) ? { mois: r.mois, cle: typeof r.cle === 'string' ? r.cle : null } : null;
  } catch { return null; }
}

export function effacerRetourCalendrier(): void {
  try { sessionStorage.removeItem(CLE); } catch { /* rien à effacer */ }
}
